module.exports = __webpack_public_path__ + "img/reco_parrainage-lazy.a03e7798.jpg";